import { Component, OnInit, Input, Output} from '@angular/core';
import {ModalWindowComponent} from "../modal-window/modal-window.component";
import {BuildingOtherRooms, ISpot, RoomTypeItem} from "../../shared/models/models";
import {ServerService} from "../../shared/services/server.service";
import { EventService } from '../../shared/services/event.service';

@Component({
  selector: 'app-parking',
  templateUrl: './parking.component.html',
  styleUrls: ['./parking.component.scss']
})
export class ParkingComponent implements OnInit {

    @Input() spotObjectAddAppartments: ISpot;


    onchangeModel = false;
    parkingTypes: RoomTypeItem[] = [];
    buildingOtherRooms: BuildingOtherRooms;
    buildingOtherRoomsSet: BuildingOtherRooms[] = [];

    constructor(private modalWindow: ModalWindowComponent,
                private serverService: ServerService, private event: EventService) {}

    ngOnInit() {
        this.buildingOtherRooms = {
            BuildingID: this.spotObjectAddAppartments.id,
            Delete: false,
            Area: null,
            RoomTypeItemID: null,
            PlaceCount: null,
            PhotoFileID: 0
        };
        if(this.spotObjectAddAppartments.parkingRooms.length>0){
            for(let rooms of this.spotObjectAddAppartments.parkingRooms){
                this.parkingTypes.push(Object.assign({}, rooms));
            }
        }else{

        }
    }

    changedModel(){
        this.onchangeModel = true;
    }

    cancel(){
        this.parkingTypes = [];
        this.buildingOtherRooms = null;
        this.buildingOtherRoomsSet = [];
        this.modalWindow.closeModalWindow();
    }

    saveState(){
        for(let i=0; i<this.parkingTypes.length;i++){

            if (!this.parkingTypes.find(x => x.id === 304).checked) {
                this.parkingTypes.find(x => x.id === 30401).checked = false;
                this.parkingTypes.find(x => x.id === 30402).checked = false;
                this.parkingTypes.find(x => x.id === 30403).checked = false;
            }

            if (this.parkingTypes.find(x => x.id === 304).checked && !this.parkingTypes.find(x => x.id === 30401).checked && !this.parkingTypes.find(x => x.id === 30402).checked
            && !this.parkingTypes.find(x => x.id === 30403).checked) {
                this.parkingTypes.find(x => x.id === 304).checked = false;
			}

            
            this.spotObjectAddAppartments.parkingRooms[i].checked = this.parkingTypes[i].checked;           
            this.buildingOtherRooms.RoomTypeItemID = this.parkingTypes[i].id;
			this.buildingOtherRooms.Area = this.parkingTypes[i].area;
			this.buildingOtherRooms.Delete = !this.parkingTypes[i].checked;
            this.buildingOtherRooms.PlaceCount = this.parkingTypes[i].placeCount;

			this.buildingOtherRoomsSet.push(Object.assign({}, this.buildingOtherRooms));

        }       
        this.setOtherRoooms(this.buildingOtherRoomsSet);
    this.event.initialize.emit(this.spotObjectAddAppartments);

    }

    setOtherRoooms(buildingRoom){
        this.serverService.setBuildingOtherRoomsWf(buildingRoom).then( res => {
            this.cancel();
        });
    }
}
